import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Global } from "../../Variables/Global";

const OrderDetailsAR = ({ modalData, show, setShow }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let t = 0;
    modalData.OrderDetails.forEach(i => {
      t += i.OriginalPrice * i.Quantity;
    });
    setTotal(t);
  }, [modalData]);

  return (
    <Modal
      show={show}
      fullscreen
      onHide={() => setShow(false)}
      dir="rtl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          الطلب #{modalData.OrderNumber || modalData.OrderId}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* ===== Address ===== */}
        <div className="card mb-4 border-0 shadow-sm">
          <div className="card-body">
            <h6 className="mb-2">عنوان التوصيل</h6>
            <p className="mb-1">
              <b>
                {modalData.AddressBook.FirstName}{" "}
                {modalData.AddressBook.LastName}
              </b>
            </p>
            <p className="mb-1">{modalData.AddressBook.Address1}</p>
            <p className="mb-1">{modalData.AddressBook.Address2}</p>
            <p className="mb-0">
              رقم الهاتف: {modalData.AddressBook.PhoneNumber}
            </p>
          </div>
        </div>

        {/* ===== Items ===== */}
        <h6 className="mb-3">
          {modalData.OrderDetails.length}{" "}
          {modalData.OrderDetails.length > 1 ? "منتجات" : "منتج"}
        </h6>

        {modalData.OrderDetails.map((item, index) => (
          <div key={index} className="card mb-3 border-0 shadow-sm">
            <div className="card-body">
              <div className="row align-items-center">

                {/* Image */}
                <div className="col-3 col-md-2">
                  <img
                    src={Global.PHOTO_URL + item.ProductDetails.ImageUrl}
                    className="img-fluid rounded"
                    alt={item.ProductDetails.ProductNameAR}
                  />
                </div>

                {/* Info */}
                <div className="col-9 col-md-6">
                  <h6 className="mb-1">
                    {item.ProductDetails.ProductNameAR}
                    {item.AttributesValues?.length > 0 && (
                      <span className="text-muted">
                        {" "}({item.AttributesValues.join(" / ")})
                      </span>
                    )}
                  </h6>

                  <small className="text-muted">
                    SKU: {item.Sku}
                  </small>

                  <p className="mb-0">
                    الكمية: ×{item.Quantity}
                  </p>
                </div>

                {/* Price */}
                <div className="col-md-4 text-md-start mt-2 mt-md-0">
                  <p className="mb-1">
                    السعر: AED {item.OriginalPrice}
                  </p>
                  <b>
                    المجموع: AED {item.TotalPriceItem}
                  </b>
                </div>

              </div>
            </div>
          </div>
        ))}

        {/* ===== Total ===== */}
        <div className="card border-0 shadow-sm mt-4">
          <div className="card-body d-flex justify-content-between">
            <h5>الإجمالي</h5>
            <h5 className="text-danger">
              {modalData.Currency} {total}
            </h5>
          </div>
        </div>

        {/* ===== Notes ===== */}
        {modalData.Notes && (
          <div className="mt-3">
            <b>ملاحظات:</b>
            <p>{modalData.Notes}</p>
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
};

export default OrderDetailsAR;
